import {
  HiOutlineHome,
  HiOutlineMail,
  // HiOutlineUsers
} from 'react-icons/hi';
import {
  TbCalendar,
  TbChartHistogram,
  // TbFile,
  // TbFileInvoice,
  TbLockAccess,
  TbUsers,
} from 'react-icons/tb';
import { FaRegCalendarAlt, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import {
  RiFileList3Line,
  RiHeartLine,
  // RiImageLine,
  RiLockPasswordLine,
  // RiMedicineBottleLine,
  RiMoneyDollarCircleLine,
  // RiStethoscopeLine,
  // RiUserHeartLine,
  RiUserLine,
} from 'react-icons/ri';
import { GiChemicalDrop } from 'react-icons/gi';
import {
  MdListAlt,
  MdOutlineAttachMoney,
  // MdOutlineCampaign,
  // MdOutlineInventory2,
  MdOutlinePanoramaPhotosphereSelect,
  MdOutlineTextsms,
} from 'react-icons/md';
import { AiOutlineSetting } from 'react-icons/ai';
import { BiCalendar, BiUserPlus } from 'react-icons/bi';
import { IoNotifications } from 'react-icons/io5';

export const MenuDatas = [
  {
    title: 'Inicio',
    path: '/',
    icon: HiOutlineHome,
  },
  {
    title: 'Pacientes',
    path: '/patients',
    icon: TbUsers,
  },
  // {
  //   title: 'Receptions',
  //   path: '/receptions',
  //   icon: HiOutlineUsers,
  // },
  // {
  //   title: 'Doctors',
  //   path: '/doctors',
  //   icon: RiUserHeartLine,
  // },

  {
    title: 'Agenda',
    path: '/appointments',
    icon: FaRegCalendarAlt,
  },
  {
    title: 'Análisis y Laboratorios',
    path: '/laboratories',
    icon: GiChemicalDrop,
  },
  {
    title: 'Pagos',
    path: '/payments',
    icon: MdListAlt,
  },
  // {
  //   title: 'Invoices',
  //   path: '/invoices',
  //   icon: TbFileInvoice,
  // },
  // {
  //   title: 'Services',
  //   path: '/services',
  //   icon: MdOutlineInventory2,
  // },
  // {
  //   title: 'Medicine',
  //   path: '/medicine',
  //   icon: RiMedicineBottleLine,
  // },
  {
    title: 'Notificaciones',
    path: '/notifications',
    icon: IoNotifications,
  },
  {
    title: 'Configuracion',
    path: '/settings',
    icon: AiOutlineSetting,
  },
];
export const memberData = [
  {
    id: 1,
    title: 'Hugo Lloris',
    image: '/images/user1.png',
    admin: false,
    email: 'hugolloris@gmail.com',
    phone: '+1 234 567 890',
    age: 25,
    gender: 'Male',
    blood: 'A+',
    totalAppointments: 5,
    date: '20 Aug 2021',
  },
  {
    id: 2,
    title: 'Mauris auctor',
    image: '/images/user2.png',
    admin: false,
    email: 'maurisauctor@gmail.com',
    phone: '+1 456 789 123',
    age: 34,
    gender: 'Female',
    blood: 'B+',
    totalAppointments: 3,
    date: '22 Nov 2023',
  },
  {
    id: 3,
    title: 'Michael Owen',
    image: '/images/user3.png',
    admin: false,
    phone: '+1 890 123 456',
    email: 'michaelowen@gmail.com',
    age: 45,
    gender: 'Male',
    blood: 'O+',
    totalAppointments: 26,
    date: '12 Jan 2020',
  },
  {
    id: 4,
    title: 'Amina Smith',
    image: '/images/user4.png',
    admin: true,
    phone: '+1 908 765 432',
    email: 'aminasmith@gmail.com',
    age: 28,
    gender: 'Female',
    blood: 'AB+',
    totalAppointments: 17,
    date: '07 Feb 2001',
  },
  {
    id: 5,
    title: 'Minahil Khan',
    image: '/images/user5.png',
    admin: false,
    phone: '+1 890 123 456',
    email: 'minahilkhan@gmail.com',
    age: 35,
    gender: 'Female',
    blood: 'A+',
    totalAppointments: 9,
    date: '30 Dec 2019',
  },
  {
    id: 6,
    title: 'Alex Morgan',
    image: '/images/user6.png',
    admin: false,
    phone: '+1 908 765 432',
    email: 'alexmorgan@gmail.com',
    age: 29,
    gender: 'Male',
    blood: 'B+',
    totalAppointments: 34,
    date: '12 Jan 2020',
  },
  {
    id: 7,
    title: 'John Doe',
    image: '/images/user7.png',
    admin: false,
    phone: '+1 234 567 890',
    email: 'johndoe@gmail.com',
    age: 32,
    gender: 'Male',
    blood: 'O-',
    totalAppointments: 12,
    date: '18 Mar 2023',
  },
  {
    id: 8,
    title: 'David Beckham',
    image: '/images/user8.png',
    admin: false,
    phone: '+1 456 789 123',
    email: 'davidbackham@gmail.com',
    age: 27,
    gender: 'Female',
    blood: 'AB+',
    totalAppointments: 70,
    date: '01 June 2018',
  },
];

export const sortsDatas = {
  status: [
    {
      id: 1,
      name: 'Status...',
    },
    {
      id: 2,
      name: 'Pendiente',
    },
    {
      id: 3,
      name: 'Aprobado',
    },
    {
      id: 4,
      name: 'Cancelado',
    },
  ],
  method: [
    {
      id: 1,
      name: 'Payment method',
    },
    {
      id: 2,
      name: 'Cash',
    },
    {
      id: 3,
      name: 'NHCF Insurance',
    },
    {
      id: 4,
      name: 'Britam Insurance',
    },
  ],
  currency: [
    {
      id: 1,
      name: 'Select Currency',
    },
    {
      id: 2,
      name: 'USD (US Dollar)',
    },
    {
      id: 3,
      name: 'EUR (Euro)',
    },
    {
      id: 4,
      name: 'TSH (Tanzanian Shilling)',
    },
  ],
  instractions: [
    {
      id: 0,
      name: 'Ninguno',
    },
    {
      id: 1,
      name: 'Cada 8 horas',
    },
    {
      id: 2,
      name: 'Despues de cada comida',
    },
    {
      id: 3,
      name: 'Antes de cada comida',
    },
  ],
  measure: [
    {
      id: 1,
      name: 'Select Measure',
    },
    {
      id: 2,
      name: 'mg',
    },
    {
      id: 3,
      name: 'ml',
    },
    {
      id: 4,
      name: 'gm',
    },
    {
      id: 5,
      name: 'kg',
    },
    {
      id: 6,
      name: 'lb',
    },
    {
      id: 7,
      name: 'tbsp',
    },
    {
      id: 8,
      name: 'tablet',
    },
    {
      id: 9,
      name: 'capsule',
    },
  ],
  stocks: [
    {
      id: 1,
      name: 'All',
    },
    {
      id: 2,
      name: 'Available',
    },
    {
      id: 3,
      name: 'Out of Stock',
    },
  ],
  service: [
    {
      id: 1,
      name: 'All',
    },
    {
      id: 2,
      name: 'Enabled',
    },
    {
      id: 3,
      name: 'Disabled',
    },
  ],
  title: [
    {
      id: 1,
      name: 'Dr.',
    },
    {
      id: 2,
      name: 'Mr.',
    },
    {
      id: 3,
      name: 'Mrs.',
    },
    {
      id: 4,
      name: 'Ms.',
    },
  ],
  filterPatient: [
    {
      id: 1,
      name: 'Ordenar por...',
    },
    {
      id: 2,
      name: 'Pacientes nuevos',
    },
    {
      id: 3,
      name: 'Pacientes antiguos',
    },
  ],
  genderFilter: [
    {
      id: 1,
      name: 'Femenino',
    },
    {
      id: 2,
      name: 'Masculino',
    },
    {
      id: 3,
      name: 'Otro'
    }
  ],
  maritalStatus: [
  {
		id: 1,
		name: 'Soltero/a',
	},
	{
		id: 2,
		name: 'Casado/a',
	},
	{
		id: 3,
		name: 'Divorciado/a',
	},
	{
		id: 4,
		name: 'Viudo/a'
	}
  ],
  bloodTypeFilter: [
    {
      id: 1,
      name: 'Ninguno',
    },
    {
      id: 2,
      name: 'A+',
    },
    {
      id: 3,
      name: 'A-',
    },
    {
      id: 4,
      name: 'B+',
    },
    {
      id: 5,
      name: 'B-',
    },
    {
      id: 6,
      name: 'AB+',
    },
    {
      id: 7,
      name: 'AB-',
    },
    {
      id: 8,
      name: 'O+',
    },
    {
      id: 9,
      name: 'O-',
    },
  ],
  dosage: [
    {
      id: 1,
      name: 'Mañana (M)',
      value: 'morning',
    },
    {
      id: 2,
      name: 'Tarde (T)',
      value: 'afternoon',
    },
    {
      id: 3,
      name: 'Noche (N)',
      value: 'evening',
    },
  ],
};

export const campaignData = [
  {
    id: 1,
    title: 'Offer on Dental Checkup',
    date: '3 days ago',
    type: 'email',
    sendTo: 'All Patients',
    action: {
      subject: 'Delight patients with a free dental checkup',
      message:
        'Dear Patient, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.',
      subHeader: 'Offer on Dental Checkup',
      header: 'How to avail this offer?',
      footer: 'This offer is valid till 30th June, 2021',
    },
  },
  {
    id: 2,
    title: 'Britam Insurance Offer',
    date: '8 days ago',
    type: 'whatsapp',
    sendTo: 'Britam Patients',
    action: {
      message:
        'Hellow Patient, are you looking for a free dental checkup? We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.',
    },
  },
  {
    id: 3,
    title: 'NHCF Insurance Offer',
    date: '10 days ago',
    type: 'sms',
    sendTo: 'NHCF Patients',
    action: {
      message:
        'Hola, Delight patient with NHCF Insurance, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.',
    },
  },
  {
    id: 4,
    title: 'Cash patients offer',
    date: '15 days ago',
    type: 'sms',
    sendTo: 'Cash Patients',
    action: {
      message:
        'Delight Patient, now get 50% off on dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.',
    },
  },
  {
    id: 5,
    title: 'Braces Offer',
    date: '12 days ago',
    type: 'email',
    sendTo: 'Britam Patients',
    action: {
      subject: 'Delight patients with a free dental checkup',
      message:
        'Dear Patient, Britam Insurance is delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.',
      subHeader: 'Braces Offer for Britam Patients',
      header: 'Now get braces at 50% off',
      footer: 'This offer is valid till 30th June, 2021',
    },
  },
  {
    id: 6,
    title: 'Teeth Whitening Offer',
    date: '20 days ago',
    type: 'whatsapp',
    sendTo: 'All Patients',
    action: {
      message:
        'Hola, Delight patient with Teeth Whitening Offer, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.',
    },
  },
];
export const servicesData = [
	{
		id: 2,
		name: "Consulta dermatológica",
		price: 40000,
		date: "23 June, 2021",
		status: true,
	},
	{
		id: 3,
		name: "Reconsulta dermatológica",
		price: 20000,
		date: "12 Jan, 2022",
		status: true,
	},
	{
		id: 4,
		name: "Crioterapia",
		price: 50000,
		date: "11 April, 2023",
		status: false,
	},
	{
		id: 5,
		name: "Electrocirugía",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 6,
		name: "Limpieza facial profunda",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 7,
		name: "Microdermoabrasión",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 8,
		name: "Dermapen",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 9,
		name: "Infiltración con corticoide",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 10,
		name: "Resección con punch",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 11,
		name: "Biopsia",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	},
	{
		id: 12,
		name: "Peeling",
		price: 34000,
		date: "10 Agst, 2021",
		status: true,
	}
]

export const invoicesData = [
  {
    id: 206719,
    to: memberData[5],
    total: 6070,
    createdDate: '12/06/2021',
    dueDate: '16/06/2021',
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 500,
        description:
          'Root Canal Treatment with X-Ray and Consultation is included in this package',
      },
      {
        id: 2,
        name: servicesData[0].name,
        price: 300,
        description: 'Teeth Whitening Treatment',
      },
      {
        id: 3,
        name: servicesData[1].name,
        price: 260,
        description: 'Dental Implants Treatment',
      },
      {
        id: 4,
        name: servicesData[2].name,
        price: 190000,
        description: 'Dental Crowns Treatment',
      },
      {
        id: 5,
        name: servicesData[3].name,
        price: 15000,
        description: 'Dental Bridges Treatment',
      },
    ],
  },
  {
    id: 198772,
    to: memberData[6],
    total: 5000,
    createdDate: '10/02/2023',
    dueDate: '14/02/2023',
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 190000,
        description: 'Dental Crowns Treatment',
      },
      {
        id: 2,
        name: servicesData[2].name,
        price: 15000,
        description: 'Dental Bridges Treatment',
      },
      {
        id: 3,
        name: servicesData[1].name,
        price: 20000,
        description: 'Dentures Treatment',
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 190000,
        description: 'Dental Crowns Treatment',
      },
    ],
  },
  {
    id: 456789,
    to: memberData[7],
    total: 10000,
    createdDate: '09/01/2023',
    dueDate: '13/01/2023',
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 5000,
        description: 'Dental Veneers Treatment',
      },
      {
        id: 2,
        name: servicesData[1].name,
        price: 16000,
        description: 'Dental Braces Treatment',
      },
      {
        id: 3,
        name: servicesData[2].name,
        price: 10000,
        description: 'Dental Sealants Treatment',
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 20000,
        description: 'Dentures Treatment',
      },
    ],
  },
  {
    id: 876543,
    to: memberData[4],
    total: 19000,
    createdDate: '08/01/2023',
    dueDate: '12/01/2023',
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 5000,
        description: 'Dental Veneers Treatment',
      },
      {
        id: 2,
        name: servicesData[1].name,
        price: 16000,
        description: 'Dental Braces Treatment',
      },
      {
        id: 3,
        name: servicesData[2].name,
        price: 10000,
        description: 'Dental Sealants Treatment',
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 20000,
        description: 'Dentures Treatment',
      },
      {
        id: 5,
        name: servicesData[3].name,
        price: 190000,
        description: 'Dental Crowns Treatment',
      },
      {
        id: 6,
        name: servicesData[1].name,
        price: 15000,
        description: 'Dental Bridges Treatment',
      },
    ],
  },
];

export const appointmentsData = [
  {
    id: 1,
    time: '+ 2 hrs',
    user: memberData[4],
    from: '10:00 AM',
    to: '12:00 PM',
    hours: 2,
    status: 'Pending',
    doctor: memberData[0],
    date: 'Jun 12, 2021',
  },
  {
    id: 2,
    time: '+ 1 hrs',
    user: memberData[5],
    from: '13:00 Pm',
    to: '18:00 PM',
    hours: 5,
    status: 'Cancel',
    doctor: memberData[1],
    date: 'Feb 24, 2021',
  },
  {
    id: 3,
    time: '- 2 hrs',
    user: memberData[6],
    from: '10:00 AM',
    to: '12:00 PM',
    hours: 2,
    status: 'Approved',
    doctor: memberData[2],
    date: 'Mar 12, 2023',
  },
  {
    id: 4,
    time: '- 3 hrs',
    user: memberData[7],
    from: '06:00 AM',
    to: '08:00 AM',
    hours: 3,
    status: 'Pending',
    doctor: memberData[3],
    date: 'Apr 06, 2023',
  },
  {
    id: 5,
    time: '- 4 hrs',
    user: memberData[3],
    from: '10:00 AM',
    to: '12:00 PM',
    hours: 7,
    status: 'Approved',
    doctor: memberData[4],
    date: 'May 18, 2023',
  },
];

export const transactionData = [
  {
    id: 1,
    user: memberData[0],
    date: 'Mar 12, 2022',
    amount: 1000,
    status: 'Paid',
    method: 'Cash',
    doctor: memberData[3],
  },
  {
    id: 2,
    user: memberData[1],
    date: 'Agus 12, 2023',
    amount: 2300,
    status: 'Paid',
    method: 'NHCF',
    doctor: memberData[4],
  },
  {
    id: 3,
    user: memberData[2],
    date: 'Jan 06, 2024',
    amount: 1200,
    status: 'Pending',
    method: 'Britam',
    doctor: memberData[5],
  },
  {
    id: 4,
    user: memberData[3],
    date: 'Feb 18, 2025',
    amount: 1400,
    status: 'Cancel',
    method: 'NHCF',
    doctor: memberData[6],
  },
  {
    id: 5,
    user: memberData[4],
    date: 'Mar 12, 2026',
    amount: 1230,
    status: 'Pending',
    method: 'Cash',
    doctor: memberData[7],
  },
  {
    id: 6,
    user: memberData[5],
    date: 'Apr 12, 2027',
    amount: 1000,
    status: 'Paid',
    method: 'NHCF',
    doctor: memberData[0],
  },
  {
    id: 7,
    user: memberData[6],
    date: 'May 12, 2028',
    amount: 8900,
    status: 'Cancel',
    method: 'Britam',
    doctor: memberData[1],
  },
  {
    id: 8,
    user: memberData[7],
    date: 'Jun 12, 2029',
    amount: 1000,
    status: 'Pending',
    method: 'Britam',
    doctor: memberData[2],
  },
];

export const dashboardCards = [
  {
    id: 1,
    title: 'Pacientes en Total',
    icon: TbUsers,
    value: 160,
    // percent: 45.06,
    color: ['bg-subMain', 'text-subMain', '#66B5A3'],
    datas: [9, 8, 5, 5, 9, 7, 7, 5, 10, 2, 9, 6],
  },
  {
    id: 2,
    title: 'Citas',
    icon: TbCalendar,
    value: 130,
    // percent: 25.06,
    color: ['bg-yellow-500', 'text-yellow-500', '#F9C851'],
    datas: [20, 50, 75, 15, 108, 97, 70, 41, 50, 20, 90, 60],
  },
  // {
  //   id: 3,
  //   title: 'Prescriptions',
  //   icon: TbFile,
  //   value: 4160,
  //   percent: 65.06,
  //   color: ['bg-green-500', 'text-green-500', '#34C759'],
  //   datas: [92, 80, 45, 15, 49, 77, 70, 51, 110, 20, 90, 60],
  // },
  {
    id: 4,
    title: 'Total Pagos',
    icon: MdOutlineAttachMoney,
    value: 45900,
    // percent: 45.06,
    color: ['bg-red-500', 'text-red-500', '#FF3B30'],
    datas: [200, 500, 750, 150, 1080, 970, 700, 410, 500, 200, 900, 600],
  },
];

export const notificationsData = [
  {
    id: 1,
    action: 1,
    user: memberData[0],
    time: 'Hace 2 horas',
  },
  {
    id: 2,
    action: 2,
    user: memberData[1],
    time: 'Hace 2 días',
  },
  {
    id: 3,
    action: 1,
    user: memberData[2],
    time: 'Hace 3 días',
  },
  {
    id: 4,
    action: 2,
    user: memberData[3],
    time: 'Hace 4 días',
  },
];

export const shareData = [
  {
    id: 1,
    icon: HiOutlineMail,
    title: 'Email',
    description: 'Send to patient email address',
  },
  {
    id: 2,
    icon: MdOutlineTextsms,
    title: 'SMS',
    description: 'Send to patient phone number',
  },
  {
    id: 3,
    icon: FaWhatsapp,
    title: 'WhatsApp',
    description: 'Send to patient WhatsApp account',
  },
  {
    id: 4,
    icon: FaTelegramPlane,
    title: 'Telegram',
    description: 'Send to patient Telegram account',
  },
];

export const medicineData = [
  {
    id: 1,
    name: 'Paracetamol',
    measure: 'Tablet',
    stock: 400,
    price: 1000,
    status: 'Available',
    instraction: 'After meal',
  },
  {
    id: 2,
    name: 'Amoxicillin',
    measure: 'Capsule',
    stock: 200,
    price: 2300,
    status: 'Available',
    instraction: 'After meal',
  },
  {
    id: 3,
    name: 'Ibuprofen',
    measure: 'mm',
    stock: 0,
    price: 5000,
    status: 'Out of stock',
    instraction: 'Before meal',
  },
  {
    id: 4,
    name: 'Aspirin',
    measure: 'cm',
    stock: 370,
    price: 3500,
    status: 'Available',
    instraction: 'After meal',
  },
  {
    id: 5,
    name: 'Diazepam',
    measure: 'gm',
    stock: 0,
    price: 12000,
    status: 'Out of stock',
    instraction: 'Before meal',
  },
  {
    id: 6,
    name: 'Lorazepam',
    measure: 'mg',
    stock: 123,
    price: 15500,
    status: 'Available',
    instraction: 'Before meal',
  },
  {
    id: 7,
    name: 'Codeine',
    measure: 'ml',
    stock: 1,
    price: 30000,
    status: 'Available',
    instraction: 'After meal',
  },
  {
    id: 8,
    name: 'Tramadol',
    measure: 'lb',
    stock: 0,
    price: 200,
    status: 'Out of stock',
    instraction: 'Before meal',
  },
];

export const patientTab = [
  {
    id: 0,
    title: 'Vista 360°',
    icon: MdOutlinePanoramaPhotosphereSelect,
  },
  {
    id: 1,
    title: 'Historial Medico',
    icon: TbChartHistogram,
  },
  {
    id: 2,
    title: 'Agenda',
    icon: BiCalendar,
  },
  // {
  //   id: 3,
  //   title: 'Invoices',
  //   icon: RiFileList3Line,
  // },
  {
    id: 4,
    title: 'Pagos',
    icon: RiMoneyDollarCircleLine,
  },
  // {
  //   id: 5,
  //   title: 'Imagenes',
  //   icon: RiImageLine,
  // },
  // {
  //   id: 6,
  //   title: 'Antecedentes Clinicos',
  //   icon: RiStethoscopeLine,
  // },
  {
    id: 7,
    title: 'Informacion del paciente',
    icon: RiUserLine,
  },
  {
    id: 8,
    title: 'Antecedentes Clinicos',
    icon: RiHeartLine,
  },
];

export const doctorTab = [
  {
    id: 1,
    title: 'Personal Information',
    icon: RiUserLine,
  },
  {
    id: 2,
    title: 'Patients',
    icon: BiUserPlus,
  },
  {
    id: 3,
    title: 'Appointments',
    icon: BiCalendar,
  },
  {
    id: 4,
    title: 'Payments',
    icon: RiMoneyDollarCircleLine,
  },
  {
    id: 5,
    title: 'Invoices',
    icon: RiFileList3Line,
  },
  {
    id: 6,
    title: 'Access Control',
    icon: TbLockAccess,
  },
  {
    id: 7,
    title: 'Change Password',
    icon: RiLockPasswordLine,
  },
];

export const medicalRecodData = [
  {
    id: 1,
    date: '13, Enero 2023',
    amount: 150000,
    tipo: 'Consulta',
    data: [
      {
        id: 1,
        title: 'Sintomas',
        value: 'Tos, Dolor de Cabeza, emorragia',
      },
      {
        id: 2,
        title: 'Diagnostico',
        value: 'Resfrio, Pulmonia',
      },
      {
        id: 3,
        title: 'Prescripción',
        value: 'Paracetamol, Amoxicillin, Ibuprofen, Aspirin',
      },
    ],
    attachments: [
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
    ],
    vitalSigns: [
      'Blood Pressure: 120/80 mmHg',
      'Pulse Rate: 80 bpm',
      'Respiratory Rate: 16 bpm',
      'Temperature: 36.5 °C',
      'Oxygen Saturation: 98%',
    ],
  },
  {
    id: 2,
    date: '13, Enero 2022',
    amount: 150000,
    tipo: 'Control',
    data: [
      {
        id: 2,
        title: 'Sintomas',
        value: 'Tos, Dolor de Cabeza, emorragia',
      },
      {
        id: 2,
        title: 'Diagnostico',
        value: 'Resfrio, Pulmonia',
      },
      {
        id: 3,
        title: 'Prescripción',
        value: 'Paracetamol, Amoxicillin, Ibuprofen, Aspirin',
      },
    ],
    attachments: [
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
    ],
    vitalSigns: [
      'Blood Pressure: 120/80 mmHg',
      'Pulse Rate: 80 bpm',
      'Respiratory Rate: 16 bpm',
      'Temperature: 36.5 °C',
      'Oxygen Saturation: 98%',
    ],
  },
  {
    id: 3,
    date: '13, Enero 2021',
    amount: 150000,
    tipo: 'Reconsulta',
    data: [
      {
        id: 1,
        title: 'Sintomas',
        value: 'Tos, Dolor de Cabeza, emorragia',
      },
      {
        id: 2,
        title: 'Diagnostico',
        value: 'Resfrio, Pulmonia',
      },
      {
        id: 3,
        title: 'Prescripción',
        value: 'Paracetamol, Amoxicillin, Ibuprofen, Aspirin',
      },
    ],
    attachments: [
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
      'https://placehold.it/300x300',
    ],
    vitalSigns: [
      'Blood Pressure: 120/80 mmHg',
      'Pulse Rate: 80 bpm',
      'Respiratory Rate: 16 bpm',
      'Temperature: 36.5 °C',
      'Oxygen Saturation: 98%',
    ],
  },
];

export const doctorsData = [
  {
    id: 1,
    user: memberData[0],
    title: 'Dr.',
  },
  {
    id: 2,
    user: memberData[1],
    title: 'Dr.',
  },
  {
    id: 3,
    user: memberData[2],
    title: 'Dr.',
  },
  {
    id: 4,
    user: memberData[3],
    title: 'Dr.',
  },
];

export const receptionsData = [
  {
    id: 1,
    user: memberData[6],
    title: 'Dr.',
  },
  {
    id: 2,
    user: memberData[7],
    title: 'Dr.',
  },
  {
    id: 3,
    user: memberData[5],
    title: 'Dr.',
  },
  {
    id: 4,
    user: memberData[4],
    title: 'Dr.',
  },
  {
    id: 5,
    user: memberData[2],
    title: 'Dr.',
  },
  {
    id: 6,
    user: memberData[1],
    title: 'Dr.',
  },
];

export const Pediatrics = {
  WeightMountGirls: {
    sdneg3:[2.0,2.7,3.4,4.0,4.4,4.8,5.1,5.3,5.6,5.8,5.9,6.1,6.3,6.4,6.6,6.7,6.9,7.0,7.2,7.3,7.5,7.6,7.8,7.9,8.1,8.2,8.4,8.5,8.6,8.8,8.9,9.0,9.1,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1],
    sdneg2:[2.4,3.2,3.9,4.5,5.0,5.4,5.7,6.0,6.3,6.5,6.7,6.9,7.0,7.2,7.4,7.6,7.7,7.9,8.1,8.2,8.4,8.6,8.7,8.9,9.0,9.2,9.4,9.5,9.7,9.8,10.0,10.1,10.3,10.4,10.5,10.7,10.8,10.9,11.1,11.2,11.3,11.5,11.6,11.7,11.8,12.0,12.1,12.2,12.3,12.4,12.6,12.7,12.8,12.9,13.0,13.2,13.3,13.4,13.5,13.6,13.7],
    sdneg1:[2.8,3.6,4.5,5.2,5.7,6.1,6.5,6.8,7.0,7.3,7.5,7.7,7.9,8.1,8.3,8.5,8.7,8.9,9.1,9.2,9.4,9.6,9.8,10.0,10.2,10.3,10.5,10.7,10.9,11.1,11.2,11.4,11.6,11.7,11.9,12.0,12.2,12.4,12.5,12.7,12.8,13.0,13.1,13.3,13.4,13.6,13.7,13.9,14.0,14.2,14.3,14.5,14.6,14.8,14.9,15.1,15.2,15.3,15.5,15.6,15.8],
    median:[3.2,4.2,5.1,5.8,6.4,6.9,7.3,7.6,7.9,8.2,8.5,8.7,8.9,9.2,9.4,9.6,9.8,10.0,10.2,10.4,10.6,10.9,11.1,11.3,11.5,11.7,11.9,12.1,12.3,12.5,12.7,12.9,13.1,13.3,13.5,13.7,13.9,14.0,14.2,14.4,14.6,14.8,15.0,15.2,15.3,15.5,15.7,15.9,16.1,16.3,16.4,16.6,16.8,17.0,17.2,17.3,17.5,17.7,17.9,18.0,18.2],
    sd1:[3.7,4.8,5.8,6.6,7.3,7.8,8.2,8.6,9.0,9.3,9.6,9.9,10.1,10.4,10.6,10.9,11.1,11.4,11.6,11.8,12.1,12.3,12.5,12.8,13.0,13.3,13.5,13.7,14.0,14.2,14.4,14.7,14.9,15.1,15.4,15.6,15.8,16.0,16.3,16.5,16.7,16.9,17.2,17.4,17.6,17.8,18.1,18.3,18.5,18.8,19.0,19.2,19.4,19.7,19.9,20.1,20.3,20.6,20.8,21.0,21.2],
    sd2:[4.2,5.5,6.6,7.5,8.2,8.8,9.3,9.8,10.2,10.5,10.9,11.2,11.5,11.8,12.1,12.4,12.6,12.9,13.2,13.5,13.7,14.0,14.3,14.6,14.8,15.1,15.4,15.7,16.0,16.2,16.5,16.8,17.1,17.3,17.6,17.9,18.1,18.4,18.7,19.0,19.2,19.5,19.8,20.1,20.4,20.7,20.9,21.2,21.5,21.8,22.1,22.4,22.6,22.9,23.2,23.5,23.8,24.1,24.4,24.6,24.9],
    sd3:[4.8,6.2,7.5,8.5,9.3,10.0,10.6,11.1,11.6,12.0,12.4,12.8,13.1,13.5,13.8,14.1,14.5,14.8,15.1,15.4,15.7,16.0,16.4,16.7,17.0,17.3,17.7,18.0,18.3,18.7,19.0,19.3,19.6,20.0,20.3,20.6,20.9,21.3,21.6,22.0,22.3,22.7,23.0,23.4,23.7,24.1,24.5,24.8,25.2,25.5,25.9,26.3,26.6,27.0,27.4,27.7,28.1,28.5,28.8,29.2,29.5]
  },

  WeightMountBoys: {
    sdneg3: [2.1,2.9,3.8,4.4,4.9,5.3,5.7,5.9,6.2,6.4,6.6,6.8,6.9,7.1,7.2,7.4,7.5,7.7,7.8,8.0,8.1,8.2,8.4,8.5,8.6,8.8,8.9,9.0,9.1,9.2,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.2,12.3,12.4],
    sdneg2: [2.5,3.4,4.3,5.0,5.6,6.0,6.4,6.7,6.9,7.1,7.4,7.6,7.7,7.9,8.1,8.3,8.4,8.6,8.8,8.9,9.1,9.2,9.4,9.5,9.7,9.8,10.0,10.1,10.2,10.4,10.5,10.7,10.8,10.9,11.0,11.2,11.3,11.4,11.5,11.6,11.8,11.9,12.0,12.1,12.2,12.4,12.5,12.6,12.7,12.8,12.9,13.1,13.2,13.3,13.4,13.5,13.6,13.7,13.8,14.0,14.1],
    sdneg1: [2.9,3.9,4.9,5.7,6.2,6.7,7.1,7.4,7.7,8.0,8.2,8.4,8.6,8.8,9.0,9.2,9.4,9.6,9.8,10.0,10.1,10.3,10.5,10.7,10.8,11.0,11.2,11.3,11.5,11.7,11.8,12.0,12.1,12.3,12.4,12.6,12.7,12.9,13.0,13.1,13.3,13.4,13.6,13.7,13.8,14.0,14.1,14.3,14.4,14.5,14.7,14.8,15.0,15.1,15.2,15.4,15.5,15.6,15.8,15.9,16.0],
    median: [3.3,4.5,5.6,6.4,7.0,7.5,7.9,8.3,8.6,8.9,9.2,9.4,9.6,9.9,10.1,10.3,10.5,10.7,10.9,11.1,11.3,11.5,11.8,12.0,12.2,12.4,12.5,12.7,12.9,13.1,13.3,13.5,13.7,13.8,14.0,14.2,14.3,14.5,14.7,14.8,15.0,15.2,15.3,15.5,15.7,15.8,16.0,16.2,16.3,16.5,16.7,16.8,17.0,17.2,17.3,17.5,17.7,17.8,18.0,18.2,18.3],
    sd1: [3.9,5.1,6.3,7.2,7.8,8.4,8.8,9.2,9.6,9.9,10.2,10.5,10.8,11.0,11.3,11.5,11.7,12.0,12.2,12.5,12.7,12.9,13.2,13.4,13.6,13.9,14.1,14.3,14.5,14.8,15.0,15.2,15.4,15.6,15.8,16.0,16.2,16.4,16.6,16.8,17.0,17.2,17.4,17.6,17.8,18.0,18.2,18.4,18.6,18.8,19.0,19.2,19.4,19.6,19.8,20.0,20.2,20.4,20.6,20.8,21.0],
    sd2: [4.4,5.8,7.1,8.0,8.7,9.3,9.8,10.3,10.7,11.0,11.4,11.7,12.0,12.3,12.6,12.8,13.1,13.4,13.7,13.9,14.2,14.5,14.7,15.0,15.3,15.5,15.8,16.1,16.3,16.6,16.9,17.1,17.4,17.6,17.8,18.1,18.3,18.6,18.8,19.0,19.3,19.5,19.7,20.0,20.2,20.5,20.7,20.9,21.2,21.4,21.7,21.9,22.2,22.4,22.7,22.9,23.2,23.4,23.7,23.9,24.2],
    sd3: [5.0,6.6,8.0,9.0,9.7,10.4,10.9,11.4,11.9,12.3,12.7,13.0,13.3,13.7,14.0,14.3,14.6,14.9,15.3,15.6,15.9,16.2,16.5,16.8,17.1,17.5,17.8,18.1,18.4,18.7,19.0,19.3,19.6,19.9,20.2,20.4,20.7,21.0,21.3,21.6,21.9,22.1,22.4,22.7,23.0,23.3,23.6,23.9,24.2,24.5,24.8,25.1,25.4,25.7,26.0,26.3,26.6,26.9,27.2,27.6,27.9],
  },

  LengthMountGirls: {
    sdneg3: [43.6,47.8,51.0,53.5,55.6,57.4,58.9,60.3,61.7,62.9,64.1,65.2,66.3,67.3,68.3,69.3,70.2,71.1,72.0,72.8,73.7,74.5,75.2,76.0,76.8,77.5,78.1,78.8,79.5,80.1,80.7,81.3,81.9,82.5,83.1,83.6,84.2,84.7,85.3,85.8,86.3,86.8,87.4,87.9,88.4,88.9,89.3,89.8,90.3,90.7,91.2,91.7,92.1,92.6,93.0,93.4,93.9,94.3,94.7,95.2],
    sdneg2: [45.4,49.8,53.0,55.6,57.8,59.6,61.2,62.7,64.0,65.3,66.5,67.7,68.9,70.0,71.0,72.0,73.0,74.0,74.9,75.8,76.7,77.5,78.4,79.3,80.0,80.8,81.5,82.2,82.9,83.6,84.3,84.9,85.6,86.2,86.8,87.4,88.0,88.6,89.2,89.8,90.4,90.9,91.5,92.0,92.5,93.1,93.6,94.1,94.6,95.1,95.6,96.1,96.6,97.1,97.6,98.1,98.5,99.0,99.5,99.9],
    sdneg1: [47.3,51.7,55.0,57.7,59.9,61.8,63.5,65.0,66.4,67.7,69.0,70.3,71.4,72.6,73.7,74.8,75.8,76.8,77.8,78.8,79.7,80.6,81.5,82.5,83.3,84.1,84.9,85.7,86.4,87.1,87.9,88.6,89.3,89.9,90.6,91.2,91.9,92.5,93.1,93.8,94.4,95.0,95.6,96.2,96.7,97.3,97.9,98.4,99.0,99.5,100.1,100.6,101.1,101.6,102.2,102.7,103.2,103.7,104.2,104.7],
    median: [49.1,53.7,57.1,59.8,62.1,64.0,65.7,67.3,68.7,70.1,71.5,72.8,74.0,75.2,76.4,77.5,78.6,79.7,80.7,81.7,82.7,83.7,84.6,85.7,86.6,87.4,88.3,89.1,89.9,90.7,91.4,92.2,92.9,93.6,94.4,95.1,95.7,96.4,97.1,97.7,98.4,99.0,99.7,100.3,100.9,101.5,102.1,102.7,103.3,103.9,104.5,105.0,105.6,106.2,106.7,107.3,107.8,108.4,108.9,109.4],
    sd1: [51.0,55.6,59.1,61.9,64.3,66.2,68.0,69.6,71.1,72.6,73.9,75.3,76.6,77.8,79.1,80.2,81.4,82.5,83.6,84.7,85.7,86.7,87.7,88.9,89.9,90.8,91.7,92.5,93.4,94.2,95.0,95.8,96.6,97.4,98.1,98.9,99.6,100.3,101.0,101.7,102.4,103.1,103.8,104.5,105.1,105.8,106.4,107.0,107.7,108.3,108.9,109.5,110.1,110.7,111.3,111.9,112.5,113.0,113.6,114.2],
    sd2: [52.9,57.6,61.1,64.0,66.4,68.5,70.3,71.9,73.5,75.0,76.4,77.8,79.2,80.5,81.7,83.0,84.2,85.4,86.5,87.6,88.7,89.8,90.8,92.2,93.1,94.1,95.0,96.0,96.9,97.7,98.6,99.4,100.3,101.1,101.9,102.7,103.4,104.2,105.0,105.7,106.4,107.2,107.9,108.6,109.3,110.0,110.7,111.3,112.0,112.7,113.3,114.0,114.6,115.2,115.9,116.5,117.1,117.7,118.3,118.9],
    sd3: [54.7,59.5,63.2,66.1,68.6,70.7,72.5,74.2,75.8,77.4,78.9,80.3,81.7,83.1,84.4,85.7,87.0,88.2,89.4,90.6,91.7,92.9,94.0,95.4,96.4,97.4,98.4,99.4,100.3,101.3,102.2,103.1,103.9,104.8,105.6,106.5,107.3,108.1,108.9,109.7,110.5,111.2,112.0,112.7,113.5,114.2,114.9,115.7,116.4,117.1,117.7,118.4,119.1,119.8,120.4,121.1,121.8,122.4,123.1,123.7]
  },

  LengthMountBoys: {
    sdneg3: [44.2,48.9,52.4,55.3,57.6,59.6,61.2,62.7,64.0,65.2,66.4,67.6,68.6,69.6,70.6,71.6,72.5,73.3,74.2,75.0,75.8,76.5,77.2,78.0,78.7,79.3,79.9,80.5,81.1,81.7,82.3,82.8,83.4,83.9,84.4,85.0,85.5,86.0,86.5,87.0,87.5,88.0,88.4,88.9,89.4,89.8,90.3,90.7,91.2,91.6,92.1,92.5,93.0,93.4,93.9,94.3,94.7,95.2,95.6,96.1],
    sdneg2: [46.1,50.8,54.4,57.3,59.7,61.7,63.3,64.8,66.2,67.5,68.7,69.9,71.0,72.1,73.1,74.1,75.0,76.0,76.9,77.7,78.6,79.4,80.2,81.0,81.7,82.5,83.1,83.8,84.5,85.1,85.7,86.4,86.9,87.5,88.1,88.7,89.2,89.8,90.3,90.9,91.4,91.9,92.4,93.0,93.5,94.0,94.4,94.9,95.4,95.9,96.4,96.9,97.4,97.8,98.3,98.8,99.3,99.7,100.2,100.7],
    sdneg1: [48.0,52.8,56.4,59.4,61.8,63.8,65.5,67.0,68.4,69.7,71.0,72.2,73.4,74.5,75.6,76.6,77.6,78.6,79.6,80.5,81.4,82.3,83.1,83.9,84.8,85.6,86.4,87.1,87.8,88.5,89.2,89.9,90.5,91.1,91.8,92.4,93.0,93.6,94.2,94.7,95.3,95.9,96.4,97.0,97.5,98.1,98.6,99.1,99.7,100.2,100.7,101.2,101.7,102.3,102.8,103.3,103.8,104.3,104.8,105.3],
    median: [49.9,54.7,58.4,61.4,63.9,65.9,67.6,69.2,70.6,72.0,73.3,74.5,75.7,76.9,78.0,79.1,80.2,81.2,82.3,83.2,84.2,85.1,86.0,86.9,87.8,88.8,89.6,90.4,91.2,91.9,92.7,93.4,94.1,94.8,95.4,96.1,96.7,97.4,98.0,98.6,99.2,99.9,100.4,101.0,101.6,102.2,102.8,103.3,103.9,104.4,105.0,105.6,106.1,106.7,107.2,107.8,108.3,108.9,109.4,110.0],
    sd1: [51.8,56.7,60.4,63.5,66.0,68.0,69.8,71.3,72.8,74.2,75.6,76.9,78.1,79.3,80.5,81.7,82.8,83.9,85.0,86.0,87.0,88.0,89.0,89.9,90.9,92.0,92.9,93.7,94.5,95.3,96.1,96.9,97.6,98.4,99.1,99.8,100.5,101.2,101.8,102.5,103.2,103.8,104.5,105.1,105.7,106.3,106.9,107.5,108.1,108.7,109.3,109.9,110.5,111.1,111.7,112.3,112.8,113.4,114.0,114.6],
    sd2: [53.7,58.6,62.4,65.5,68.0,70.1,71.9,73.5,75.0,76.5,77.9,79.2,80.5,81.8,83.0,84.2,85.4,86.5,87.7,88.8,89.8,90.9,91.9,92.9,93.9,95.2,96.1,97.0,97.9,98.7,99.6,100.4,101.2,102.0,102.7,103.5,104.2,105.0,105.7,106.4,107.1,107.8,108.5,109.1,109.8,110.4,111.1,111.7,112.4,113.0,113.6,114.2,114.9,115.5,116.1,116.7,117.4,118.0,118.6,119.2],
    sd3: [55.6,60.6,64.4,67.6,70.1,72.2,74.0,75.7,77.2,78.7,80.1,81.5,82.9,84.2,85.5,86.7,88.0,89.2,90.4,91.5,92.6,93.8,94.9,95.9,97.0,98.3,99.3,100.3,101.2,102.1,103.0,103.9,104.8,105.6,106.4,107.2,108.0,108.8,109.5,110.3,111.0,111.7,112.5,113.2,113.9,114.6,115.2,115.9,116.6,117.3,117.9,118.6,119.2,119.9,120.6,121.2,121.9,122.6,123.2,123.9],
  },

  WeightLengthGirls02: {
    sdneg3: [1.9,2.0,2.0,2.1,2.2,2.2,2.3,2.4,2.4,2.5,2.6,2.7,2.8,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.1,4.2,4.3,4.4,4.5,4.6,4.7,4.8,4.9,5.0,5.1,5.2,5.3,5.4,5.5,5.5,5.6,5.7,5.8,5.9,6.0,6.1,6.1,6.2,6.3,6.4,6.5,6.5,6.6,6.7,6.8,6.9,6.9,7.0,7.1,7.1,7.2,7.3,7.4,7.4,7.5,7.6,7.7,7.7,7.8,7.9,8.0,8.1,8.1,8.2,8.3,8.4,8.5,8.6,8.7,8.8,8.9,9.0,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.3,12.4,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.5,13.6,13.7,13.9,14.0],
    sdneg2: [2.1,2.1,2.2,2.3,2.4,2.4,2.5,2.6,2.6,2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.1,4.3,4.4,4.5,4.6,4.7,4.8,4.9,5.0,5.1,5.2,5.3,5.4,5.5,5.6,5.7,5.8,5.9,6.0,6.1,6.2,6.3,6.4,6.5,6.6,6.7,6.8,6.9,6.9,7.0,7.1,7.2,7.3,7.4,7.4,7.5,7.6,7.7,7.8,7.8,7.9,8.0,8.1,8.2,8.2,8.3,8.4,8.5,8.6,8.7,8.8,8.8,8.9,9.0,9.1,9.2,9.3,9.4,9.5,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,12.0,12.1,12.2,12.3,12.4,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.5,13.6,13.7,13.8,14.0,14.1,14.3,14.4,14.5,14.7,14.8,15.0,15.1,15.3],
    sdneg1: [2.3,2.3,2.4,2.5,2.6,2.6,2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.5,4.6,4.8,4.9,5.0,5.1,5.3,5.4,5.5,5.6,5.7,5.8,5.9,6.0,6.2,6.3,6.4,6.5,6.6,6.7,6.8,6.9,7.0,7.1,7.2,7.3,7.4,7.5,7.6,7.7,7.7,7.8,7.9,8.0,8.1,8.2,8.3,8.4,8.5,8.5,8.6,8.7,8.8,8.9,9.0,9.1,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.7,11.8,11.9,12.0,12.1,12.2,12.3,12.4,12.6,12.7,12.8,12.9,13.0,13.1,13.3,13.4,13.5,13.6,13.7,13.9,14.0,14.1,14.3,14.4,14.5,14.7,14.8,15.0,15.1,15.3,15.4,15.6,15.7,15.9,16.0,16.2,16.4,16.5,16.7],
    median: [2.5,2.5,2.6,2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.5,4.7,4.8,5.0,5.1,5.2,5.4,5.5,5.6,5.7,5.9,6.0,6.1,6.3,6.4,6.5,6.6,6.7,6.9,7.0,7.1,7.2,7.3,7.4,7.5,7.6,7.7,7.9,8.0,8.1,8.2,8.3,8.4,8.5,8.6,8.7,8.8,8.9,9.0,9.1,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.9,11.0,11.1,11.2,11.3,11.5,11.6,11.7,11.8,12.0,12.1,12.2,12.3,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.5,13.6,13.7,13.8,14.0,14.1,14.2,14.4,14.5,14.6,14.8,14.9,15.0,15.2,15.3,15.5,15.6,15.8,15.9,16.1,16.2,16.4,16.5,16.7,16.9,17.1,17.2,17.4,17.6,17.8,18.0,18.1,18.3],
    sd1: [2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.6,4.7,4.8,5.0,5.1,5.3,5.4,5.6,5.7,5.9,6.0,6.2,6.3,6.4,6.6,6.7,6.9,7.0,7.1,7.3,7.4,7.5,7.6,7.8,7.9,8.0,8.1,8.3,8.4,8.5,8.6,8.7,8.8,9.0,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.2,11.3,11.4,11.5,11.6,11.8,11.9,12.0,12.1,12.3,12.4,12.6,12.7,12.8,13.0,13.1,13.2,13.4,13.5,13.7,13.8,13.9,14.1,14.2,14.3,14.5,14.6,14.7,14.9,15.0,15.2,15.3,15.4,15.6,15.7,15.9,16.0,16.2,16.3,16.5,16.6,16.8,17.0,17.1,17.3,17.5,17.6,17.8,18.0,18.2,18.4,18.5,18.7,18.9,19.1,19.3,19.5,19.7,20.0,20.2],
    sd2: [3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.6,4.7,4.9,5.0,5.2,5.3,5.5,5.7,5.8,6.0,6.1,6.3,6.5,6.6,6.8,6.9,7.1,7.3,7.4,7.6,7.7,7.8,8.0,8.1,8.3,8.4,8.6,8.7,8.8,9.0,9.1,9.2,9.4,9.5,9.6,9.7,9.9,10.0,10.1,10.2,10.3,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.3,12.4,12.5,12.6,12.8,12.9,13.1,13.2,13.3,13.5,13.6,13.8,13.9,14.1,14.2,14.4,14.5,14.7,14.8,15.0,15.1,15.3,15.5,15.6,15.8,15.9,16.1,16.2,16.4,16.5,16.7,16.8,17.0,17.1,17.3,17.5,17.6,17.8,18.0,18.1,18.3,18.5,18.7,18.9,19.0,19.2,19.4,19.6,19.8,20.0,20.2,20.5,20.7,20.9,21.1,21.3,21.6,21.8,22.0,22.3],
    sd3: [3.3,3.4,3.5,3.6,3.7,3.8,4.0,4.1,4.2,4.3,4.5,4.6,4.8,4.9,5.1,5.2,5.4,5.5,5.7,5.9,6.1,6.3,6.4,6.6,6.8,7.0,7.1,7.3,7.5,7.7,7.8,8.0,8.2,8.4,8.5,8.7,8.8,9.0,9.1,9.3,9.5,9.6,9.8,9.9,10.0,10.2,10.3,10.5,10.6,10.7,10.9,11.0,11.1,11.3,11.4,11.5,11.7,11.8,11.9,12.0,12.2,12.3,12.4,12.5,12.6,12.8,12.9,13.0,13.1,13.3,13.4,13.5,13.7,13.8,13.9,14.1,14.2,14.4,14.5,14.7,14.9,15.0,15.2,15.4,15.5,15.7,15.9,16.0,16.2,16.4,16.5,16.7,16.9,17.0,17.2,17.4,17.5,17.7,17.9,18.0,18.2,18.4,18.6,18.7,18.9,19.1,19.3,19.5,19.6,19.8,20.0,20.2,20.4,20.6,20.8,21.0,21.3,21.5,21.7,21.9,22.2,22.4,22.6,22.9,23.1,23.4,23.6,23.9,24.2,24.4,24.7],
  },

  WeightLengthBoys02: {
    sdneg3: [1.9,1.9,2.0,2.1,2.1,2.2,2.3,2.3,2.4,2.5,2.6,2.7,2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.6,3.7,3.8,3.9,4.0,4.1,4.3,4.4,4.5,4.6,4.7,4.8,4.9,5.0,5.1,5.2,5.3,5.4,5.5,5.6,5.7,5.8,5.9,6.0,6.1,6.2,6.3,6.4,6.5,6.6,6.6,6.7,6.8,6.9,7.0,7.1,7.2,7.2,7.3,7.4,7.5,7.6,7.6,7.7,7.8,7.9,7.9,8.0,8.1,8.2,8.2,8.3,8.4,8.5,8.5,8.6,8.7,8.8,8.9,9.0,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.2,12.3,12.4,12.5,12.6,12.7,12.8,12.9,13.0,13.2,13.3,13.4,13.5,13.6,13.7,13.8,14.0,14.1,14.2],
    sdneg2: [2.0,2.1,2.2,2.3,2.3,2.4,2.5,2.6,2.6,2.7,2.8,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.7,3.8,4.0,4.1,4.2,4.3,4.5,4.6,4.7,4.8,5.0,5.1,5.2,5.3,5.4,5.6,5.7,5.8,5.9,6.0,6.1,6.2,6.3,6.4,6.5,6.6,6.7,6.8,6.9,7.0,7.1,7.2,7.3,7.4,7.5,7.6,7.6,7.7,7.8,7.9,8.0,8.1,8.2,8.3,8.3,8.4,8.5,8.6,8.7,8.7,8.8,8.9,9.0,9.1,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.2,12.3,12.4,12.5,12.6,12.7,12.8,12.9,13.0,13.2,13.3,13.4,13.5,13.6,13.7,13.9,14.0,14.1,14.2,14.4,14.5,14.6,14.7,14.9,15.0,15.1,15.3,15.4],
    sdneg1: [2.2,2.3,2.4,2.5,2.5,2.6,2.7,2.8,2.9,3.0,3.0,3.1,3.2,3.3,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.6,4.7,4.9,5.0,5.1,5.3,5.4,5.5,5.6,5.8,5.9,6.0,6.1,6.2,6.4,6.5,6.6,6.7,6.8,6.9,7.0,7.1,7.2,7.3,7.5,7.6,7.7,7.8,7.9,8.0,8.1,8.2,8.3,8.4,8.5,8.6,8.7,8.8,8.8,8.9,9.0,9.1,9.2,9.3,9.4,9.5,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.5,10.6,10.7,10.8,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.8,11.9,12.0,12.1,12.2,12.3,12.4,12.5,12.6,12.7,12.8,12.9,13.1,13.2,13.3,13.4,13.5,13.6,13.7,13.9,14.0,14.1,14.2,14.4,14.5,14.6,14.8,14.9,15.0,15.2,15.3,15.4,15.6,15.7,15.9,16.0,16.2,16.3,16.5,16.6,16.8],
    median: [2.4,2.5,2.6,2.7,2.8,2.9,2.9,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.8,3.9,4.0,4.1,4.3,4.4,4.5,4.7,4.8,5.0,5.1,5.3,5.4,5.6,5.7,5.9,6.0,6.1,6.3,6.4,6.5,6.7,6.8,6.9,7.0,7.1,7.3,7.4,7.5,7.6,7.7,7.9,8.0,8.1,8.2,8.3,8.4,8.5,8.6,8.8,8.9,9.0,9.1,9.2,9.3,9.4,9.5,9.6,9.7,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.4,10.5,10.6,10.7,10.8,10.9,11.0,11.2,11.3,11.4,11.5,11.6,11.7,11.9,12.0,12.1,12.2,12.4,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.4,13.5,13.7,13.8,13.9,14.0,14.1,14.3,14.4,14.5,14.6,14.8,14.9,15.0,15.2,15.3,15.4,15.6,15.7,15.9,16.0,16.2,16.3,16.5,16.6,16.8,16.9,17.1,17.3,17.4,17.6,17.8,17.9,18.1,18.3],
    sd1: [2.7,2.8,2.9,3.0,3.0,3.1,3.2,3.3,3.4,3.5,3.6,3.8,3.9,4.0,4.1,4.2,4.4,4.5,4.7,4.8,5.0,5.1,5.3,5.4,5.6,5.7,5.9,6.1,6.2,6.4,6.5,6.7,6.8,7.0,7.1,7.2,7.4,7.5,7.6,7.8,7.9,8.0,8.2,8.3,8.4,8.5,8.7,8.8,8.9,9.0,9.2,9.3,9.4,9.5,9.6,9.8,9.9,10.0,10.1,10.2,10.3,10.4,10.6,10.7,10.8,10.9,11.0,11.1,11.2,11.3,11.4,11.5,11.6,11.7,11.8,11.9,12.0,12.1,12.2,12.4,12.5,12.6,12.8,12.9,13.0,13.2,13.3,13.4,13.5,13.7,13.8,13.9,14.1,14.2,14.3,14.4,14.6,14.7,14.8,14.9,15.1,15.2,15.3,15.5,15.6,15.7,15.9,16.0,16.2,16.3,16.5,16.6,16.8,16.9,17.1,17.3,17.4,17.6,17.8,17.9,18.1,18.3,18.5,18.6,18.8,19.0,19.2,19.4,19.6,19.8,20.0],
    sd2: [3.0,3.1,3.1,3.2,3.3,3.4,3.6,3.7,3.8,3.9,4.0,4.1,4.2,4.4,4.5,4.6,4.8,4.9,5.1,5.3,5.4,5.6,5.8,5.9,6.1,6.3,6.4,6.6,6.8,7.0,7.1,7.3,7.4,7.6,7.7,7.9,8.0,8.2,8.3,8.5,8.6,8.7,8.9,9.0,9.2,9.3,9.4,9.6,9.7,9.8,10.0,10.1,10.2,10.4,10.5,10.6,10.8,10.9,11.0,11.2,11.3,11.4,11.5,11.6,11.7,11.9,12.0,12.1,12.2,12.3,12.4,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.5,13.6,13.7,13.9,14.0,14.2,14.3,14.5,14.6,14.7,14.9,15.0,15.1,15.3,15.4,15.6,15.7,15.8,16.0,16.1,16.3,16.4,16.5,16.7,16.8,17.0,17.1,17.3,17.5,17.6,17.8,18.0,18.1,18.3,18.5,18.7,18.8,19.0,19.2,19.4,19.6,19.8,20.0,20.2,20.4,20.6,20.8,21.0,21.2,21.4,21.7,21.9],
    sd3: [3.3,3.4,3.5,3.6,3.7,3.8,3.9,4.0,4.2,4.3,4.4,4.5,4.7,4.8,5.0,5.1,5.3,5.4,5.6,5.8,6.0,6.1,6.3,6.5,6.7,6.9,7.1,7.2,7.4,7.6,7.8,8.0,8.1,8.3,8.5,8.6,8.8,8.9,9.1,9.3,9.4,9.6,9.7,9.9,10.0,10.2,10.3,10.5,10.6,10.8,10.9,11.1,11.2,11.3,11.5,11.6,11.8,11.9,12.1,12.2,12.3,12.5,12.6,12.7,12.8,13.0,13.1,13.2,13.3,13.4,13.6,13.7,13.8,13.9,14.0,14.2,14.3,14.4,14.6,14.7,14.9,15.0,15.2,15.3,15.5,15.6,15.8,15.9,16.1,16.2,16.4,16.5,16.7,16.8,17.0,17.1,17.3,17.4,17.6,17.7,17.9,18.0,18.2,18.4,18.5,18.7,18.9,19.1,19.2,19.4,19.6,19.8,20.0,20.2,20.4,20.6,20.8,21.0,21.2,21.5,21.7,21.9,22.1,22.4,22.6,22.8,23.1,23.3,23.6,23.8,24.1],
  },

  WeightLengthGirls25: {
    sdneg3: [14.4,14.5,14.7,14.8,15.0,15.1,15.3,15.4,15.6,15.7,15.9,16.0,16.2,16.3,16.5,16.6,16.8,16.9,17.1,17.3],
    sdneg2: [15.7,15.8,16.0,16.2,16.3,16.5,16.7,16.8,17.0,17.2,17.3,17.5,17.7,17.8,18.0,18.2,18.4,18.5,18.7,18.9],
    sdneg1: [17.1,17.3,17.5,17.7,17.9,18.0,18.2,18.4,18.6,18.8,19.0,19.2,19.4,19.6,19.8,19.9,20.1,20.3,20.5,20.7],
    median: [18.8,19.0,19.2,19.4,19.6,19.8,20.0,20.2,20.5,20.7,20.9,21.1,21.3,21.5,21.7,22.0,22.2,22.4,22.6,22.8],
    sd1: [20.7,20.9,21.2,21.4,21.6,21.8,22.1,22.3,22.6,22.8,23.0,23.3,23.5,23.8,24.0,24.2,24.5,24.7,25.0,25.2],
    sd2: [22.9,23.1,23.4,23.6,23.9,24.2,24.4,24.7,25.0,25.2,25.5,25.8,26.1,26.3,26.6,26.9,27.2,27.4,27.7,28.0],
    sd3: [25.4,25.7,26.0,26.2,26.5,26.8,27.1,27.4,27.8,28.1,28.4,28.7,29.0,29.3,29.6,29.9,30.3,30.6,30.9,31.2],
  },

  WeightLengthBoys25: {
    sdneg3: [14.5,14.6,14.8,14.9,15.0,15.2,15.3,15.4,15.6,15.7,15.8,16.0,16.1,16.2,16.4,16.5,16.7,16.8,16.9,17.1],
    sdneg2: [15.8,15.9,16.0,16.2,16.3,16.5,16.6,16.8,16.9,17.1,17.2,17.4,17.5,17.7,17.9,18.0,18.2,18.3,18.5,18.6],
    sdneg1: [17.1,17.3,17.5,17.6,17.8,18.0,18.1,18.3,18.5,18.6,18.8,19.0,19.2,19.3,19.5,19.7,19.9,20.0,20.2,20.4],
    median: [18.7,18.9,19.1,19.2,19.4,19.6,19.8,20.0,20.2,20.4,20.6,20.8,21.0,21.2,21.4,21.6,21.8,22.0,22.2,22.4],
    sd1: [20.4,20.7,20.9,21.1,21.3,21.5,21.7,21.9,22.1,22.4,22.6,22.8,23.0,23.3,23.5,23.7,23.9,24.1,24.4,24.6],
    sd2: [22.4,22.7,22.9,23.1,23.4,23.6,23.9,24.1,24.4,24.6,24.9,25.1,25.4,25.6,25.9,26.1,26.4,26.6,26.9,27.2],
    sd3: [24.7,25.0,25.2,25.5,25.8,26.0,26.3,26.6,26.9,27.2,27.5,27.8,28.0,28.3,28.6,28.9,29.2,29.5,29.8,30.1],
  },

  HeadCircunferenceGirls: {
    sdneg3: [30.3,33.0,34.6,35.8,36.8,37.6,38.3,38.9,39.4,39.8,40.2,40.5,40.8,41.1,41.3,41.5,41.7,41.9,42.1,42.3,42.4,42.6,42.7,42.9,43.0,43.1,43.3,43.4,43.5,43.6,43.7,43.8,43.9,44.0,44.1,44.2,44.3,44.4,44.4,44.5,44.6,44.6,44.7,44.8,44.8,44.9,45.0,45.0,45.1,45.1,45.2,45.2,45.3,45.3,45.4,45.4,45.5,45.5,45.6,45.6,45.7],
    sdneg2: [31.5,34.2,35.8,37.1,38.1,38.9,39.6,40.2,40.7,41.2,41.5,41.9,42.2,42.4,42.7,42.9,43.1,43.3,43.5,43.6,43.8,44.0,44.1,44.3,44.4,44.5,44.7,44.8,44.9,45.0,45.1,45.2,45.3,45.4,45.5,45.6,45.7,45.8,45.8,45.9,46.0,46.1,46.1,46.2,46.3,46.3,46.4,46.4,46.5,46.5,46.6,46.7,46.7,46.8,46.8,46.9,46.9,46.9,47.0,47.0,47.1],
    sdneg1: [32.7,35.4,37.0,38.3,39.3,40.2,40.9,41.5,42.0,42.5,42.9,43.2,43.5,43.8,44.1,44.3,44.5,44.7,44.9,45.0,45.2,45.3,45.5,45.6,45.8,45.9,46.1,46.2,46.3,46.4,46.5,46.6,46.7,46.8,46.9,47.0,47.1,47.2,47.3,47.3,47.4,47.5,47.5,47.6,47.7,47.7,47.8,47.9,47.9,48.0,48.0,48.1,48.1,48.2,48.2,48.3,48.3,48.4,48.4,48.5,48.5],
    median: [33.9,36.5,38.3,39.5,40.6,41.5,42.2,42.8,43.4,43.8,44.2,44.6,44.9,45.2,45.4,45.7,45.9,46.1,46.2,46.4,46.6,46.7,46.9,47.0,47.2,47.3,47.5,47.6,47.7,47.8,47.9,48.0,48.1,48.2,48.3,48.4,48.5,48.6,48.7,48.7,48.8,48.9,49.0,49.0,49.1,49.2,49.2,49.3,49.3,49.4,49.4,49.5,49.5,49.6,49.6,49.7,49.7,49.8,49.8,49.9,49.9],
    sd1: [35.1,37.7,39.5,40.8,41.8,42.7,43.5,44.1,44.7,45.2,45.6,45.9,46.3,46.5,46.8,47.0,47.2,47.4,47.6,47.8,48.0,48.1,48.3,48.4,48.6,48.7,48.9,49.0,49.1,49.2,49.3,49.4,49.6,49.7,49.7,49.8,49.9,50.0,50.1,50.2,50.2,50.3,50.4,50.4,50.5,50.6,50.6,50.7,50.8,50.8,50.9,50.9,51.0,51.0,51.1,51.1,51.2,51.2,51.3,51.3,51.3],
    sd2: [36.2,38.9,40.7,42.0,43.1,44.0,44.8,45.5,46.0,46.5,46.9,47.3,47.6,47.9,48.2,48.4,48.6,48.8,49.0,49.2,49.4,49.5,49.7,49.8,50.0,50.1,50.3,50.4,50.5,50.6,50.7,50.9,51.0,51.1,51.2,51.2,51.3,51.4,51.5,51.6,51.7,51.7,51.8,51.9,51.9,52.0,52.1,52.1,52.2,52.2,52.3,52.3,52.4,52.4,52.5,52.5,52.6,52.6,52.7,52.7,52.8],
    sd3: [37.4,40.1,41.9,43.3,44.4,45.3,46.1,46.8,47.4,47.8,48.3,48.6,49.0,49.3,49.5,49.8,50.0,50.2,50.4,50.6,50.7,50.9,51.1,51.2,51.4,51.5,51.7,51.8,51.9,52.0,52.2,52.3,52.4,52.5,52.6,52.7,52.7,52.8,52.9,53.0,53.1,53.1,53.2,53.3,53.3,53.4,53.5,53.5,53.6,53.6,53.7,53.8,53.8,53.9,53.9,54.0,54.0,54.1,54.1,54.1,54.2],
  },

  HeadCircunferenceBoys: {
    sdneg3: [30.7,33.8,35.6,37.0,38.0,38.9,39.7,40.3,40.8,41.2,41.6,41.9,42.2,42.5,42.7,42.9,43.1,43.2,43.4,43.5,43.7,43.8,43.9,44.1,44.2,44.3,44.4,44.5,44.6,44.7,44.8,44.8,44.9,45.0,45.1,45.1,45.2,45.3,45.3,45.4,45.4,45.5,45.5,45.6,45.6,45.7,45.7,45.8,45.8,45.9,45.9,45.9,46.0,46.0,46.1,46.1,46.1,46.2,46.2,46.2,46.3],
    sdneg2: [31.9,34.9,36.8,38.1,39.2,40.1,40.9,41.5,42.0,42.5,42.9,43.2,43.5,43.8,44.0,44.2,44.4,44.6,44.7,44.9,45.0,45.2,45.3,45.4,45.5,45.6,45.8,45.9,46.0,46.1,46.1,46.2,46.3,46.4,46.5,46.6,46.6,46.7,46.8,46.8,46.9,46.9,47.0,47.0,47.1,47.1,47.2,47.2,47.3,47.3,47.4,47.4,47.5,47.5,47.5,47.6,47.6,47.6,47.7,47.7,47.7],
    sdneg1: [33.2,36.1,38.0,39.3,40.4,41.4,42.1,42.7,43.3,43.7,44.1,44.5,44.8,45.0,45.3,45.5,45.7,45.9,46.0,46.2,46.4,46.5,46.6,46.8,46.9,47.0,47.1,47.2,47.3,47.4,47.5,47.6,47.7,47.8,47.9,48.0,48.0,48.1,48.2,48.2,48.3,48.4,48.4,48.5,48.5,48.6,48.7,48.7,48.7,48.8,48.8,48.9,48.9,49.0,49.0,49.1,49.1,49.1,49.2,49.2,49.2],
    median: [34.5,37.3,39.1,40.5,41.6,42.6,43.3,44.0,44.5,45.0,45.4,45.8,46.1,46.3,46.6,46.8,47.0,47.2,47.4,47.5,47.7,47.8,48.0,48.1,48.3,48.4,48.5,48.6,48.7,48.8,48.9,49.0,49.1,49.2,49.3,49.4,49.5,49.5,49.6,49.7,49.7,49.8,49.9,49.9,50.0,50.1,50.1,50.2,50.2,50.3,50.3,50.4,50.4,50.4,50.5,50.5,50.6,50.6,50.7,50.7,50.7],
    sd1: [35.7,38.4,40.3,41.7,42.8,43.8,44.6,45.2,45.8,46.3,46.7,47.0,47.4,47.6,47.9,48.1,48.3,48.5,48.7,48.9,49.0,49.2,49.3,49.5,49.6,49.7,49.9,50.0,50.1,50.2,50.3,50.4,50.5,50.6,50.7,50.8,50.9,51.0,51.0,51.1,51.2,51.3,51.3,51.4,51.4,51.5,51.6,51.6,51.7,51.7,51.8,51.8,51.9,51.9,52.0,52.0,52.1,52.1,52.1,52.2,52.2],
    sd2: [37.0,39.6,41.5,42.9,44.0,45.0,45.8,46.4,47.0,47.5,47.9,48.3,48.6,48.9,49.2,49.4,49.6,49.8,50.0,50.2,50.4,50.5,50.7,50.8,51.0,51.1,51.2,51.4,51.5,51.6,51.7,51.8,51.9,52.0,52.1,52.2,52.3,52.4,52.5,52.5,52.6,52.7,52.8,52.8,52.9,53.0,53.0,53.1,53.1,53.2,53.2,53.3,53.4,53.4,53.5,53.5,53.5,53.6,53.6,53.7,53.7],
    sd3: [38.3,40.8,42.6,44.1,45.2,46.2,47.0,47.7,48.3,48.8,49.2,49.6,49.9,50.2,50.5,50.7,51.0,51.2,51.4,51.5,51.7,51.9,52.0,52.2,52.3,52.5,52.6,52.7,52.9,53.0,53.1,53.2,53.3,53.4,53.5,53.6,53.7,53.8,53.9,54.0,54.1,54.1,54.2,54.3,54.3,54.4,54.5,54.5,54.6,54.7,54.7,54.8,54.8,54.9,54.9,55.0,55.0,55.1,55.1,55.2,55.2],
  }
};

export const Categories = {
  age_complete: ['0', '1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60'],
  age_0_2: ['0', '1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101', '102', '103', '104'],
  age_2_5: ['25','26','27','28','29','30','31','32','33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59','60']
};
